import {
  Map,
  fromJS,
} from 'immutable'
import {
  SET_MULTIPLE_PM_PLACEMENTS_PROCESSING,
  SET_PM_PLACEMENT,
  SET_PM_PLACEMENT_PROCESSING,
  SET_PM_PLACEMENT_ERROR,
} from './actions'

export const initialState = Map()

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case SET_PM_PLACEMENT: {
      const { placementName, language, data } = action.payload
      return state.withMutations((mutableState) => {
        mutableState
          .setIn([placementName, language, 'processing'], false)
          .setIn([placementName, language, 'data'], fromJS(data))
          .deleteIn([placementName, language, 'error'])
      })
    }
    case SET_PM_PLACEMENT_PROCESSING: {
      const { placementName, language, processing } = action.payload
      return state.setIn([placementName, language, 'processing'], processing)
    }
    case SET_MULTIPLE_PM_PLACEMENTS_PROCESSING: {
      const { placementNames, language, processing } = action.payload
      return state.withMutations((mutableState) => {
        placementNames.forEach((placementName) => mutableState.setIn([placementName, language, 'processing'], processing))
      })
    }
    case SET_PM_PLACEMENT_ERROR: {
      const { placementName, language, error } = action.payload
      return state.withMutations((mutableState) => {
        mutableState
          .setIn([placementName, language, 'processing'], false)
          .deleteIn([placementName, language, 'data'])
          .setIn([placementName, language, 'error'], error)
      })
    }
    default:
      return state
  }
}

/*
Store
pmPlacement: Map({
  "member-home-spotlight-a-v1": Map({
    en: Map({
      processing: boolean,
      data: Map(),
      error: Map(),
    }),
  }),
})
*/
